import React from "react";

type Props = {};

const TrivyReport = (props: Props) => {
  return <div>TrivyReport</div>;
};

export default TrivyReport;
